import React from 'react';
import { useParams } from 'react-router-dom';

import IntegrationForm from 'pages/Hardware/Integrations/IntegrationForm';
import IntegrationsHeader from 'pages/Hardware/Integrations/IntegrationsHeader';
import { integrationMapper } from 'rdx/hardware/installer/types';

import extdevCustomerDisplay from './ExtdevCustomerDisplay';

const forms = {
  extdevCustomerDisplay,
};

function Forms() {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { level, level_id, name: integrationName } = useParams();

  const FormByIntegrationName = forms[integrationName];
  const path = `/hardware/integrations/${level}/${level_id}/customerDisplay`;
  return (
    <div className="d-flex flex-column flex-fill">
      <IntegrationsHeader
        goToPath={path}
        title={integrationMapper[integrationName].name}
        level={level}
      />
      <IntegrationForm
        integrationType="customerDisplay"
        renderForm={(props) => <FormByIntegrationName {...props} />}
      />
    </div>
  );
}

export default {
  hidden: true,
  path: '/hardware/integrations/:level/:level_id/customerDisplay/:name',
  component: Forms,
  rootPath: { name: 'Hardware', uri: '/hardware' },
  subPath: [
    { name: 'Integrations', uri: '/hardware/integrations' },
    { name: 'Customer Display' },
  ],
};

/**
 *
 *
 */
